import { Navigate, useLocation } from 'react-router-dom'
import { DASHBOARD_AUTH_PATHS, DASHBOARD_HOME, legacyAppRedirect } from '@yourownmetric/shared'

import { useAppSelector } from '@/app/hooks'

/**
 * `/` (and unknown paths) on a host that serves only the dashboard (staging, local):
 * signed in → the app, otherwise the login page. In production the edge router
 * sends `/` to the marketing website instead.
 */
export function RootRedirect() {
    const token = useAppSelector(s => s.auth.token)
    return <Navigate to={token ? DASHBOARD_HOME : DASHBOARD_AUTH_PATHS.login} replace />
}

/** Pre-`/app` bookmark (`/overview`, `/settings/api-keys?x=1#y`) → `/app/...`, keeping query and hash. */
export function LegacyAppRedirect() {
    const { pathname, search, hash } = useLocation()
    return (
        <Navigate to={`${legacyAppRedirect(pathname) ?? DASHBOARD_HOME}${search}${hash}`} replace />
    )
}

/** `/register` → `/signup`, keeping query (invite/plan params) and hash. */
export function RegisterRedirect() {
    const { search, hash } = useLocation()
    return <Navigate to={`${DASHBOARD_AUTH_PATHS.signup}${search}${hash}`} replace />
}
